import { render, staticRenderFns } from "./CitiesTownsForm.vue?vue&type=template&id=13b69602"
import script from "./CitiesTownsForm.vue?vue&type=script&lang=js"
export * from "./CitiesTownsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports